import * as React from 'react';
import { Workspace } from '../../types';
import URLManager from '../../utils/urlManager';

interface WorkspaceListProps {
  workspaces: Workspace[];
  selectedWorkspace: Workspace;
  callback: Function;
  navigate: Function;
}

export const WorkspaceList = ({
  workspaces,
  selectedWorkspace,
  callback,
  navigate
}: WorkspaceListProps) => {
  const { id } = URLManager.useRouter();
  const [typeAhead, setTypeAhead] = React.useState('');

  return (
    <>
      <input
        autoFocus
        className="form-control form-control-sm"
        value={typeAhead}
        onChange={v => {
          setTypeAhead(v.target.value);
        }}
      ></input>
      {workspaces
        ?.filter(w => {
          return (
            !typeAhead?.length ||
            w?.props?.name
              ?.toLocaleLowerCase()
              ?.includes(typeAhead?.toLocaleLowerCase())
          );
        })
        ?.map(w => (
          <div
            id={w.id}
            key={w.id}
            data-id={w.props.refId}
            onClick={() => {
              navigate(w, id ? { id } : undefined);
              callback();
            }}
            className={
              w.id == selectedWorkspace?.id
                ? 'selected-ws ws-list-item'
                : 'ws-list-item'
            }
          >
            {w.props.name}
          </div>
        ))}
    </>
  );
};
